"use client";

import { Button } from "@/components/shadcn/button";
import { useAuth0 } from "@auth0/auth0-react";
import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  text: string;
  className?: string;
  variant?: ComponentProps<typeof Button>["variant"];
};

const LogoutButton = ({
  text,
  className = "",
  variant = "secondary",
}: Props) => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <Button
      variant={variant}
      className={twMerge(className)}
      onClick={handleLogout}
      type="button"
    >
      {text}
    </Button>
  );
};

export default LogoutButton;
